define('facets_items_collection.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('facets_items_collection', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-type=\"backbone.collection.view.rows\"></div>  ";
},"useData":true}, 'extensions/AOTT/AOTT_Stage_Lighting_Store/3.6.0/', 'extensions/AOTT/AOTT_Stage_Lighting_Store/3.6.0/', Handlebars);
});